import { Item, SceneObjects } from '@types'

export default function isItem(item?: SceneObjects | string): item is Item {
  if (typeof item === 'string') return item.startsWith('items_')
  return !!item && item?.type === 'items'
}
